export const humsize = (bytes) => {
    if (bytes < 1000)
        return `${bytes} B`;
    const units = ['kB', 'MB', 'GB', 'TB'];
    let size = bytes;
    let unitIndex = -1;
    do {
        size /= 1000;
        unitIndex++;
    } while (size >= 1000 && unitIndex < units.length - 1);
    return `${size.toFixed(1).replace('.', ',')} ${units[unitIndex]}`;
};
